// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.husEKthKYJAc_0Jy {
	max-width: 1310px;
	margin: 0 auto;
	padding-bottom: 96px;
}

.husEKthKYJAc_0Jy h2 {
	color: #303030;
	font-size: 30px;
	font-weight: 600;
	margin: 0;
}

.Kq5YxlXICEqkJ9uq {
	margin: 45px 0 30px 0;
}

.D83hEwycbYxKx2Uo {
	color: #000000;
	background-color: transparent;
	border: none;
}

.D83hEwycbYxKx2Uo i {
	font-size: 16px;
	background-color: #f2e1bc;
	padding: 10px;
	border-radius: 8px;
	margin-left: 12px;
}

.husEKthKYJAc_0Jy .p-datatable-table {
	border-radius: 16px;
	overflow: hidden;
}

.husEKthKYJAc_0Jy .p-datatable-thead th {
	background-color: #f2e1bc;
	border: 1px solid #f3f5f7;
	padding: 18px 30px;
}

.husEKthKYJAc_0Jy .p-datatable-thead th:first-child > div {
	display: flex;
	justify-content: flex-start;
}

.husEKthKYJAc_0Jy .p-datatable-thead th > div {
	display: flex;
	justify-content: center;
	color: #303030;
	font-size: 18px;
}

.husEKthKYJAc_0Jy .p-datatable-tbody td {
	border: 1px solid #f3f5f7;
	padding: 9px 8px;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr td:first-child {
	text-align: left;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr .jrHaAwhIsuyHXUpT {
	display: flex;
	justify-content: center;
	align-items: center;
}

.h7jj0RHK00zGd2f8 {
	background-size: cover;
	height: 50px;
	width: 71px;
	background-color: gray;
	color: #ffffff;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 6px;
	overflow: hidden;
}

.h7jj0RHK00zGd2f8 i {
	display: none;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .h7jj0RHK00zGd2f8 i {
	display: block;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .h7jj0RHK00zGd2f8 div {
	width: 100%;
	height: 100%;
	background-color: #2e2e2e55;
	backdrop-filter: blur(2px);
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 6px;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr td {
	text-align: center;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .Ehpap2ajkkUChVNB {
	background-color: #e1e7ed;
}

.Ehpap2ajkkUChVNB {
	padding: 28px 22px;
	border-radius: 6px;
}

.pvPx2wdLwJihRKwp {
	display: flex;
	gap: 8px;
}

.pU12Ei58k8UIbHOx,
.dwmsJzJNZKY7UbfL,
.UnbL6VAQMG85HNqO {
	width: 75px;
	height: 67px;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .pU12Ei58k8UIbHOx {
	background-color: #c5f3c1;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .dwmsJzJNZKY7UbfL {
	background-color: #e1e7ed;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .UnbL6VAQMG85HNqO {
	background-color: #ffcaca;
}

.pU12Ei58k8UIbHOx span::before {
	color: #56be4d;
	font-size: 20px;
}

.UnbL6VAQMG85HNqO span::before {
	color: #dd0000;
	font-size: 20px;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .pU12Ei58k8UIbHOx span::before {
	color: #185625;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .dwmsJzJNZKY7UbfL span::before {
	color: #20336c;
}

.dwmsJzJNZKY7UbfL span::before {
	color: #4d87be;
	font-size: 20px;
}

.K2IrzQkh5MegWWVR {
	width: 114px;
	height: 67px;
}

.Mp5jVP1l42k1TjbK {
	width: 100%;
}

.Mp5jVP1l42k1TjbK > span {
	width: 100%;
	display: flex;
	justify-content: center;
	background-color: #4d87be;
	border-radius: 16px;
	padding: 14px 0px;
	font-size: 18px;
	font-weight: 600;
}

.Mp5jVP1l42k1TjbK > span:hover {
	background-color: #20336C;
}

.Mp5jVP1l42k1TjbK > span > span {
	width: fit-content;
	flex-grow: 0;
}

.husEKthKYJAc_0Jy .p-datatable-tbody tr:hover .K2IrzQkh5MegWWVR {
	background-color: #e1e7ed;
}

.pD5ouHisBTEs8Klr {
	display: inline-block;
}

.cUy_s0zrNQ88HWUr {
	background-color: #f2efea;
	padding: 20px;
	display: flex;
	justify-content: center;
}

.Tc5IpmuqkUKBNjjR {
	width: 250px;
	height: 250px;
	border-radius: 54px;
	overflow: hidden;
}

.Tc5IpmuqkUKBNjjR .yXv_pSMTUsY5eoZ7 {
	height: 173px;
	background-color: gray;
	background-size: cover;
}

.Tc5IpmuqkUKBNjjR .oUsnoH13QfsFE4Ya {
	height: 77px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-transform: uppercase;
	font-size: 16px;
	font-family: "Roboto";
	background-color: #ffffff;
}

.a2yrN1pM9CUr13gZ {
	border-radius: 16px;
	font-size: 18px;
	padding: 14px 20px;
	background-color: #ffffff;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.GdWTwEzlr4Du68Uy {
	border-radius: 16px 0 0 16px !important;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.GdLxUVfCvgNLiSVL {
	border-radius: 0 16px 16px 0 !important;
	background-color: #ffffff;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);
}

.ngVAeKi9wKA4bNF7 {
	background-color: #e1e7ed;
	border-radius: 16px;
	overflow: hidden;
}

.ngVAeKi9wKA4bNF7 .p-button {
	background-color: transparent;
	border: none;
	font-size: 20px;
	padding: 15px 0px;
}

.ngVAeKi9wKA4bNF7 .p-highlight {
	background-color: #4d87be;
	border-radius: 16px;
}

.fNUoM3vltBsE37RJ {
	width: 100%;
	background-color: #56be4d;
	border-radius: 16px;
	padding: 18px 0px;
	color: #ffffff;
	border: none;
	font-size: 20px;
	font-weight: 600;
}

.fNUoM3vltBsE37RJ:hover {
	background-color: #185625;
}

.VAGiotW2xkL4BQrh {
	width: 100%;
	background-color: #DD0000;
	border-radius: 16px;
	padding: 18px 20px;
	font-size: 20px;
	font-weight: 600;
	color: #ffffff;
	border: none;
}

.VAGiotW2xkL4BQrh:hover {
	background-color: #721010;
}

.v5e599Vj4WUNjj6p {
	width: 100%;
	background-color: #F3F5F7;
	border-radius: 16px;
	padding: 10px 20px;
	color: #4D87BE;
	font-size: 20px;
	font-weight: 600;
	border: none;
}

.v5e599Vj4WUNjj6p:hover {
	color: #305375;
}

.wrVsQ1m6_QOoOTPq {
	width: 541px !important;
	height: 354px !important;
	background-color: #F3F5F7;
	border-radius: 25px !important;
}

.wrVsQ1m6_QOoOTPq .p-dialog {
	border-radius: 25px !important;
	background-color: #F3F5F7;
}

.wrVsQ1m6_QOoOTPq .p-dialog-footer {
	border-bottom-right-radius: 25px !important;
	border-bottom-left-radius: 25px !important;
	background-color: #F3F5F7;
}

.wrVsQ1m6_QOoOTPq .p-dialog-header {
	border-top-right-radius: 25px !important;
	border-top-left-radius: 25px !important;
	background-color: #F3F5F7;
}

.wrVsQ1m6_QOoOTPq .p-dialog-content{
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.wrVsQ1m6_QOoOTPq .vR20VsIEF4UYG_kZ {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	font-size: 20px;
	font-weight: 400;
}

.wrVsQ1m6_QOoOTPq .p-dialog-title {
	font-size: 30px !important;
	font-weight: 700 !important;
}

.wrVsQ1m6_QOoOTPq .p-dialog-content {
	background-color: #F3F5F7;
}

.qTgdZiPuC1kwAW_J {
	width: 674px !important;
	height: fit-content;
	background-color: #F3F5F7;
	border-radius: 16px !important;
}

.qTgdZiPuC1kwAW_J .p-dialog {
	border-radius: 16px !important;
}

.qTgdZiPuC1kwAW_J .p-dialog-footer {
	border-bottom-right-radius: 16px !important;
	border-bottom-left-radius: 16px !important;
	background-color: #F3F5F7;
}

.qTgdZiPuC1kwAW_J .p-dialog-header {
	border-top-right-radius: 16px !important;
	border-top-left-radius: 16px !important;
	background-color: #F3F5F7;
}

.qTgdZiPuC1kwAW_J .p-dialog-title {
	font-size: 30px !important;
	font-weight: 700 !important;
}

.qTgdZiPuC1kwAW_J .p-dialog-content {
	background-color: #F3F5F7;
}

.ol_vVenJaZUL8yJl {
	margin-bottom: 52px;
	width: 100%;
}

.ol_vVenJaZUL8yJl .p-dropdown-trigger {
	margin-right: 10px;
}

.ol_vVenJaZUL8yJl .p-dropdown {
	width: 100% !important;
	text-align: left;
	border-radius: 16px;
	box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);;
	border: none;
}

.ol_vVenJaZUL8yJl .p-dropdown-label {
	display: block;
	padding: 14px 20px;
	font-size: 18px;
	font-family: "Roboto";
}

.aIW59hLseTkBO5tB {
	border-radius: 24px;
	border: 1px solid #a4a4a4;
	overflow: hidden;
	padding: 16px 20px;
}

.aIW59hLseTkBO5tB .p-dropdown-items-wrapper {
	max-height: 400px !important;
}

.aIW59hLseTkBO5tB .p-dropdown-items li {
	height: 40px;
	border-radius: 15px;
	margin: 4px 0;
	font-size: 18px;
	color: #303030;
}

.aIW59hLseTkBO5tB .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
	border: 2px solid transparent;
}

.aIW59hLseTkBO5tB .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
	border: 2px solid #20336c;
	background-color: inherit;
}

.aIW59hLseTkBO5tB .p-dropdown-item:not(.p-highlight):not(.p-disabled) {
	background-color: inherit;
}

.aIW59hLseTkBO5tB .p-dropdown-item.p-highlight {
	color: #ffffff;
	background-color: #20336c;
}

.aIW59hLseTkBO5tB .p-dropdown-item.p-highlight:after {
	content: "✓";
	position: absolute;
	right: 16px;
	font-size: 24px;
	color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/pages/Admin/components/Organizations.module.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,aAAa;CACb,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,2BAA2B;CAC3B,0BAA0B;CAC1B,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;;;CAGC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,aAAa;CACb,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,eAAe;CACf,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,yBAAyB;CACzB,sGAAsG;AACvG;;AAEA;CACC,uCAAuC;CACvC,sGAAsG;AACvG;;AAEA;CACC,uCAAuC;CACvC,yBAAyB;CACzB,sGAAsG;AACvG;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,YAAY;CACZ,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,cAAc;CACd,YAAY;CACZ,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,uBAAuB;CACvB,wBAAwB;CACxB,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;CAC9B,yBAAyB;AAC1B;;AAEA;CACC,2CAA2C;CAC3C,0CAA0C;CAC1C,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,uCAAuC;CACvC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,2CAA2C;CAC3C,0CAA0C;CAC1C,yBAAyB;AAC1B;;AAEA;CACC,wCAAwC;CACxC,uCAAuC;CACvC,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,mBAAmB;CACnB,sGAAsG;CACtG,YAAY;AACb;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,aAAa;CACb,eAAe;CACf,cAAc;AACf;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,cAAc;AACf","sourcesContent":[".pageWrapper {\r\n\tmax-width: 1310px;\r\n\tmargin: 0 auto;\r\n\tpadding-bottom: 96px;\r\n}\r\n\r\n.pageWrapper h2 {\r\n\tcolor: #303030;\r\n\tfont-size: 30px;\r\n\tfont-weight: 600;\r\n\tmargin: 0;\r\n}\r\n\r\n.header {\r\n\tmargin: 45px 0 30px 0;\r\n}\r\n\r\n.createBtn {\r\n\tcolor: #000000;\r\n\tbackground-color: transparent;\r\n\tborder: none;\r\n}\r\n\r\n.createBtn i {\r\n\tfont-size: 16px;\r\n\tbackground-color: #f2e1bc;\r\n\tpadding: 10px;\r\n\tborder-radius: 8px;\r\n\tmargin-left: 12px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-table) {\r\n\tborder-radius: 16px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th) {\r\n\tbackground-color: #f2e1bc;\r\n\tborder: 1px solid #f3f5f7;\r\n\tpadding: 18px 30px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th:first-child > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-start;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-thead th > div) {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tcolor: #303030;\r\n\tfont-size: 18px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody td) {\r\n\tborder: 1px solid #f3f5f7;\r\n\tpadding: 9px 8px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td:first-child) {\r\n\ttext-align: left;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr) .cellImageWrapper {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.imageCell {\r\n\tbackground-size: cover;\r\n\theight: 50px;\r\n\twidth: 71px;\r\n\tbackground-color: gray;\r\n\tcolor: #ffffff;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tborder-radius: 6px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.imageCell i {\r\n\tdisplay: none;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .imageCell i {\r\n\tdisplay: block;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .imageCell div {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: #2e2e2e55;\r\n\tbackdrop-filter: blur(2px);\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr td) {\r\n\ttext-align: center;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .cellInsider {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.cellInsider {\r\n\tpadding: 28px 22px;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.cellSoundWrapper {\r\n\tdisplay: flex;\r\n\tgap: 8px;\r\n}\r\n\r\n.playBtn,\r\n.soundBtn,\r\n.deleteBtn {\r\n\twidth: 75px;\r\n\theight: 67px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .playBtn {\r\n\tbackground-color: #c5f3c1;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .soundBtn {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .deleteBtn {\r\n\tbackground-color: #ffcaca;\r\n}\r\n\r\n.playBtn span::before {\r\n\tcolor: #56be4d;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.deleteBtn span::before {\r\n\tcolor: #dd0000;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .playBtn span::before {\r\n\tcolor: #185625;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .soundBtn span::before {\r\n\tcolor: #20336c;\r\n}\r\n\r\n.soundBtn span::before {\r\n\tcolor: #4d87be;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.activeBtn {\r\n\twidth: 114px;\r\n\theight: 67px;\r\n}\r\n\r\n.uploadBtn {\r\n\twidth: 100%;\r\n}\r\n\r\n.uploadBtn > span {\r\n\twidth: 100%;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\tbackground-color: #4d87be;\r\n\tborder-radius: 16px;\r\n\tpadding: 14px 0px;\r\n\tfont-size: 18px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.uploadBtn > span:hover {\r\n\tbackground-color: #20336C;\r\n}\r\n\r\n.uploadBtn > span > span {\r\n\twidth: fit-content;\r\n\tflex-grow: 0;\r\n}\r\n\r\n.pageWrapper :global(.p-datatable-tbody tr:hover) .activeBtn {\r\n\tbackground-color: #e1e7ed;\r\n}\r\n\r\n.cardWrapper {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.preview {\r\n\tbackground-color: #f2efea;\r\n\tpadding: 20px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n}\r\n\r\n.stationCard {\r\n\twidth: 250px;\r\n\theight: 250px;\r\n\tborder-radius: 54px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.stationCard .image {\r\n\theight: 173px;\r\n\tbackground-color: gray;\r\n\tbackground-size: cover;\r\n}\r\n\r\n.stationCard .titleWrapper {\r\n\theight: 77px;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\ttext-transform: uppercase;\r\n\tfont-size: 16px;\r\n\tfont-family: \"Roboto\";\r\n\tbackground-color: #ffffff;\r\n}\r\n\r\n.input {\r\n\tborder-radius: 16px;\r\n\tfont-size: 18px;\r\n\tpadding: 14px 20px;\r\n\tbackground-color: #ffffff;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.phonePrefix {\r\n\tborder-radius: 16px 0 0 16px !important;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.inputPhone {\r\n\tborder-radius: 0 16px 16px 0 !important;\r\n\tbackground-color: #ffffff;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.selectButton {\r\n\tbackground-color: #e1e7ed;\r\n\tborder-radius: 16px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.selectButton :global(.p-button) {\r\n\tbackground-color: transparent;\r\n\tborder: none;\r\n\tfont-size: 20px;\r\n\tpadding: 15px 0px;\r\n}\r\n\r\n.selectButton :global(.p-highlight) {\r\n\tbackground-color: #4d87be;\r\n\tborder-radius: 16px;\r\n}\r\n\r\n.saveBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #56be4d;\r\n\tborder-radius: 16px;\r\n\tpadding: 18px 0px;\r\n\tcolor: #ffffff;\r\n\tborder: none;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.saveBtn:hover {\r\n\tbackground-color: #185625;\r\n}\r\n\r\n.deleteDialogBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #DD0000;\r\n\tborder-radius: 16px;\r\n\tpadding: 18px 20px;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n\tcolor: #ffffff;\r\n\tborder: none;\r\n}\r\n\r\n.deleteDialogBtn:hover {\r\n\tbackground-color: #721010;\r\n}\r\n\r\n.cancelDialogBtn {\r\n\twidth: 100%;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 16px;\r\n\tpadding: 10px 20px;\r\n\tcolor: #4D87BE;\r\n\tfont-size: 20px;\r\n\tfont-weight: 600;\r\n\tborder: none;\r\n}\r\n\r\n.cancelDialogBtn:hover {\r\n\tcolor: #305375;\r\n}\r\n\r\n.deleteModal {\r\n\twidth: 541px !important;\r\n\theight: 354px !important;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 25px !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog) {\r\n\tborder-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-footer) {\r\n\tborder-bottom-right-radius: 25px !important;\r\n\tborder-bottom-left-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-header) {\r\n\tborder-top-right-radius: 25px !important;\r\n\tborder-top-left-radius: 25px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content){\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tflex-direction: column;\r\n}\r\n\r\n.deleteModal .text {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\ttext-align: center;\r\n\tfont-size: 20px;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-title) {\r\n\tfont-size: 30px !important;\r\n\tfont-weight: 700 !important;\r\n}\r\n\r\n.deleteModal :global(.p-dialog-content) {\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.organizationModal {\r\n\twidth: 674px !important;\r\n\theight: fit-content;\r\n\tbackground-color: #F3F5F7;\r\n\tborder-radius: 16px !important;\r\n}\r\n\r\n.organizationModal :global(.p-dialog) {\r\n\tborder-radius: 16px !important;\r\n}\r\n\r\n.organizationModal :global(.p-dialog-footer) {\r\n\tborder-bottom-right-radius: 16px !important;\r\n\tborder-bottom-left-radius: 16px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.organizationModal :global(.p-dialog-header) {\r\n\tborder-top-right-radius: 16px !important;\r\n\tborder-top-left-radius: 16px !important;\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.organizationModal :global(.p-dialog-title) {\r\n\tfont-size: 30px !important;\r\n\tfont-weight: 700 !important;\r\n}\r\n\r\n.organizationModal :global(.p-dialog-content) {\r\n\tbackground-color: #F3F5F7;\r\n}\r\n\r\n.dropDownWrapper {\r\n\tmargin-bottom: 52px;\r\n\twidth: 100%;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-trigger) {\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown) {\r\n\twidth: 100% !important;\r\n\ttext-align: left;\r\n\tborder-radius: 16px;\r\n\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 0 2px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.12);;\r\n\tborder: none;\r\n}\r\n\r\n.dropDownWrapper :global(.p-dropdown-label) {\r\n\tdisplay: block;\r\n\tpadding: 14px 20px;\r\n\tfont-size: 18px;\r\n\tfont-family: \"Roboto\";\r\n}\r\n\r\n.dropDownPanel {\r\n\tborder-radius: 24px;\r\n\tborder: 1px solid #a4a4a4;\r\n\toverflow: hidden;\r\n\tpadding: 16px 20px;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items-wrapper) {\r\n\tmax-height: 400px !important;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-items) li {\r\n\theight: 40px;\r\n\tborder-radius: 15px;\r\n\tmargin: 4px 0;\r\n\tfont-size: 18px;\r\n\tcolor: #303030;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n\tborder: 2px solid transparent;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus) {\r\n\tborder: 2px solid #20336c;\r\n\tbackground-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item:not(.p-highlight):not(.p-disabled)) {\r\n\tbackground-color: inherit;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight) {\r\n\tcolor: #ffffff;\r\n\tbackground-color: #20336c;\r\n}\r\n\r\n.dropDownPanel :global(.p-dropdown-item.p-highlight:after) {\r\n\tcontent: \"✓\";\r\n\tposition: absolute;\r\n\tright: 16px;\r\n\tfont-size: 24px;\r\n\tcolor: #ffffff;\r\n}"],"sourceRoot":""}]);
// Exports
export var pageWrapper = `husEKthKYJAc_0Jy`;
export var header = `Kq5YxlXICEqkJ9uq`;
export var createBtn = `D83hEwycbYxKx2Uo`;
export var cellImageWrapper = `jrHaAwhIsuyHXUpT`;
export var imageCell = `h7jj0RHK00zGd2f8`;
export var cellInsider = `Ehpap2ajkkUChVNB`;
export var cellSoundWrapper = `pvPx2wdLwJihRKwp`;
export var playBtn = `pU12Ei58k8UIbHOx`;
export var soundBtn = `dwmsJzJNZKY7UbfL`;
export var deleteBtn = `UnbL6VAQMG85HNqO`;
export var activeBtn = `K2IrzQkh5MegWWVR`;
export var uploadBtn = `Mp5jVP1l42k1TjbK`;
export var cardWrapper = `pD5ouHisBTEs8Klr`;
export var preview = `cUy_s0zrNQ88HWUr`;
export var stationCard = `Tc5IpmuqkUKBNjjR`;
export var image = `yXv_pSMTUsY5eoZ7`;
export var titleWrapper = `oUsnoH13QfsFE4Ya`;
export var input = `a2yrN1pM9CUr13gZ`;
export var phonePrefix = `GdWTwEzlr4Du68Uy`;
export var inputPhone = `GdLxUVfCvgNLiSVL`;
export var selectButton = `ngVAeKi9wKA4bNF7`;
export var saveBtn = `fNUoM3vltBsE37RJ`;
export var deleteDialogBtn = `VAGiotW2xkL4BQrh`;
export var cancelDialogBtn = `v5e599Vj4WUNjj6p`;
export var deleteModal = `wrVsQ1m6_QOoOTPq`;
export var text = `vR20VsIEF4UYG_kZ`;
export var organizationModal = `qTgdZiPuC1kwAW_J`;
export var dropDownWrapper = `ol_vVenJaZUL8yJl`;
export var dropDownPanel = `aIW59hLseTkBO5tB`;
export default ___CSS_LOADER_EXPORT___;
